<!-- Task Main Content Container -->
<div class="task-main-content">

  <!-- Task Name Input Section (Hidden in view mode) -->
  @if (!isViewMode) {
    <div class="task-name-section">
      <input type="text" class="task-name-input" [formControl]="taskNameControl" placeholder="Enter task name"
        [attr.aria-label]="'Task name'" [class.has-error]="taskNameControl.invalid && taskNameControl.touched">
      @if (taskNameControl.invalid && taskNameControl.touched) {
        <div class="task-name-error">
          <span class="error-text">Task name is required</span>
        </div>
      }
    </div>
  }

  <!-- Module & Reference Selection Section (Conditional) -->
  <!-- COMMENTED OUT: No longer needed -->
  <!--
  <div class="module-reference-section" *ngIf="isTaskModule">
    <div class="module-reference-content">
      <div class="module-selector-wrapper">
        <label class="input-label">
          <mat-icon class="label-icon">business</mat-icon>
          Module
        </label>
        <ng-select [items]="modulesList" bindLabel="name" bindValue="id" placeholder="Select a module"
          [searchable]="true" [clearable]="true" [(ngModel)]="searchParams.module_id"
          (change)="onModuleSelected($event)" class="module-dropdown">
          <ng-template ng-option-tmp let-item="item">
            <div class="module-option">
              <span class="module-name">{{ item.name }}</span>
            </div>
          </ng-template>
        </ng-select>
      </div>

      <div class="reference-selector-wrapper" *ngIf="searchParams.module_id">
        <div class="reference-search" *ngIf="showSearchInput">
          <label class="input-label">
            <mat-icon class="label-icon">search</mat-icon>
            Reference Number
          </label>
          <app-search-field [searchParams]="searchParams" (callback)="onItemSelected($event)">
          </app-search-field>
        </div>

        <div class="selected-reference" *ngIf="selectedItem && !showSearchInput">
          <div class="selected-reference-card">
            <div class="selected-reference-header">
              <mat-icon class="reference-icon">link</mat-icon>
              <div class="reference-info">
                <span class="reference-label">Selected Reference</span>
                <span class="reference-name">{{ selectedItem.name || selectedItem.reference_number }}</span>
              </div>
            </div>
            <button mat-icon-button class="clear-button" (click)="onItemCleared()"
              [attr.aria-label]="'Clear selected reference'">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  -->

  <!-- Main Content Area (scrollable) -->
  <div class="content-scrollable">

    <!-- Description Section -->
    <div class="description-section">
      <div class="section-header">
        <h3 class="section-title">
          <mat-icon class="title-icon">description</mat-icon>
          Description
        </h3>
        @if (!isEditingDescription) {
          <button mat-icon-button class="edit-button" (click)="onEditDescription()" [disabled]="isViewMode && isLocked">
            <mat-icon>edit</mat-icon>
          </button>
        }
      </div>
      <div class="description-box" [class.editing]="isEditingDescription">
        <!-- Target div for mentions (contenteditable) -->
        <div #descriptionTarget id="descriptionTarget" [attr.contenteditable]="(!isViewMode || isEditingDescription) ? 'true' : 'false'"
          class="description-textarea" [class.readonly]="isViewMode && !isEditingDescription" [attr.aria-label]="'Task description'"
          [attr.data-placeholder]="(!isViewMode || isEditingDescription) ? 'Describe the task in detail... (Use @ to mention team members)' : ''"
          (blur)="onDescriptionChange($event)"
          (input)="onDescriptionInput($event)"
          (keyup)="onDescriptionKeyup($event)">
        </div>
      </div>
      @if (isEditingDescription) {
        <div class="description-actions">
          <button type="button" class="description-actions__cancel" (click)="cancelDescriptionEdit()" [disabled]="isSavingDescription">Cancel</button>
          <button type="button" class="description-actions__save" (click)="saveDescriptionEdit()" [disabled]="isSavingDescription">Save</button>
        </div>
      }

      <!-- Custom Mention Dropdown (Portal to body with fixed positioning) -->
      @if (showMentionDropdown) {
        <div class="custom-mention-dropdown-portal"
          >
          <div class="custom-mention-dropdown"
            [style.top.px]="mentionDropdownTop"
            [style.left.px]="mentionDropdownLeft">
            <!-- Loading State -->
            @if (isMentionsLoading) {
              <div class="mention-loading">
                <mat-spinner diameter="20"></mat-spinner>
                <span>Searching...</span>
              </div>
            }
            <!-- User List -->
            @if (!isMentionsLoading && mentions.length > 0) {
              <div class="mention-list">
                @for (user of mentions; track user; let i = $index) {
                  <div class="mention-item"
                    [class.active]="i === selectedMentionIndex"
                    (click)="selectMention(user)"
                    (mouseenter)="selectedMentionIndex = i">
                    <app-profile-avatar
                      [fullName]="user.full_name"
                      [profileUrl]=" $any(user.profile_image)?.url || ''"
                      widthSize="32px"
                      heightSize="32px">
                    </app-profile-avatar>
                    <div class="mention-user-info">
                      <div class="mention-user-name">{{user.full_name}}</div>
                      <!-- <div class="mention-user-email" *ngIf="user.email">{{user.email}}</div> -->
                    </div>
                  </div>
                }
              </div>
            }
            <!-- No Results -->
            @if (!isMentionsLoading && mentions.length === 0) {
              <div class="mention-no-results">
                <mat-icon>search_off</mat-icon>
                <span>No users found</span>
              </div>
            }
          </div>
        </div>
      }
    </div>

    <!-- Milestone Card (conditional) -->
    @if (selectedMilestone) {
      <div class="milestone-section">
        <div class="section-header">
          <h3 class="section-title">
            <mat-icon class="title-icon">flag</mat-icon>
            Milestone
          </h3>
          <button mat-icon-button class="remove-button" (click)="onRemoveMilestone()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="milestone-card">
          <div class="milestone-header">
            <div class="milestone-status-indicator" [ngClass]="getMilestoneStatusClass()"></div>
            <h4 class="milestone-name">{{ selectedMilestone.name }}</h4>
            <span class="milestone-status-badge" [ngClass]="getMilestoneStatusClass() + '-badge'">
              {{ selectedMilestone.status }}
            </span>
          </div>
          <!-- Date Range with Days Remaining -->
          <div class="milestone-date-range">
            <mat-icon class="date-icon">calendar_today</mat-icon>
            @if (selectedMilestone.startDate && selectedMilestone.endDate) {
              <span>
                {{ selectedMilestone.startDate | date: 'MMM d' }} - {{ selectedMilestone.endDate | date: 'MMM d, yyyy' }}
              </span>
            }
            @if (!selectedMilestone.startDate || !selectedMilestone.endDate) {
              <span>
                Due: {{ selectedMilestone.dueDate | date: 'mediumDate' }}
              </span>
            }
            @if (selectedMilestone.daysRemaining && selectedMilestone.status !== 'completed' && selectedMilestone.status !== 'overdue') {
              <span class="days-remaining"
                >
                • {{ selectedMilestone.daysRemaining }} left
              </span>
            }
          </div>
          <!-- Progress Bar (for in-progress milestones) -->
          @if (selectedMilestone.status === 'in-progress' && selectedMilestone.progress !== undefined) {
            <div class="milestone-progress-section"
              >
              <div class="progress-bar">
                <div class="progress-fill" [style.width.%]="selectedMilestone.progress"></div>
              </div>
              <span class="progress-text">{{ selectedMilestone.progress }}%</span>
            </div>
          }
          <!-- Task Statistics -->
          @if (selectedMilestone.taskStats) {
            <div class="milestone-task-stats">
              <mat-icon class="task-icon">check_circle_outline</mat-icon>
              <span>{{ selectedMilestone.taskStats.completed }}/{{ selectedMilestone.taskStats.total }} tasks</span>
            </div>
          }
          <!-- Assigned To -->
          @if (selectedMilestone.assignedTo) {
            <div class="milestone-assigned-to">
              <mat-icon class="assigned-icon">person</mat-icon>
              <span>Assigned to: {{ selectedMilestone.assignedTo }}</span>
            </div>
          }
          @if (selectedMilestone.description) {
            <p class="milestone-description">
              {{ selectedMilestone.description }}
            </p>
          }
        </div>
      </div>
    }

    <!-- Tabs Section -->
    <div class="tabs-section">
      <mat-tab-group [(selectedIndex)]="activeTabIndex" (selectedIndexChange)="onTabChange($event)"
        animationDuration="200ms">

        <!-- Details Tab -->
        @if (!hideDetailsCommentsHistory) {
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">info</mat-icon>
              Details
            </ng-template>
            <div class="tab-content" @tabContentTransition>
              <ng-content select="[details-tab]"></ng-content>
            </div>
          </mat-tab>
        }

        <!-- Checklist Tab -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">checklist</mat-icon>
            Checklist
            @if (checklistCount > 0) {
              <span class="tab-badge">{{ checklistCount }}</span>
            }
          </ng-template>
          <div class="tab-content" @tabContentTransition>
            <ng-content select="[checklist-tab]"></ng-content>
          </div>
        </mat-tab>

        <!-- Attachments Tab -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">attach_file</mat-icon>
            Attachments
            @if (attachmentsCount > 0) {
              <span class="tab-badge">{{ attachmentsCount }}</span>
            }
          </ng-template>
          <div class="tab-content" @tabContentTransition>
            <ng-content select="[attachments-tab]"></ng-content>
          </div>
        </mat-tab>

        <!-- Comments Tab -->
        @if (!hideDetailsCommentsHistory) {
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">comment</mat-icon>
              Comments
              @if (commentsCount > 0) {
                <span class="tab-badge">{{ commentsCount }}</span>
              }
            </ng-template>
            <div class="tab-content" @tabContentTransition>
              <ng-content select="[comments-tab]"></ng-content>
            </div>
          </mat-tab>
        }

        <!-- History Tab -->
        @if (!hideDetailsCommentsHistory) {
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">history</mat-icon>
              History
            </ng-template>
            <div class="tab-content" @tabContentTransition>
              <ng-content select="[history-tab]"></ng-content>
            </div>
          </mat-tab>
        }

      </mat-tab-group>
    </div>

  </div>

</div>